import request from '../../request'
import {surveyItem} from '../../endpoints'

// Client for the survey-item endpoints on the SurveyQuestion controller:
// content screens and skip-logic sections, plus the ordered item read, reorder
// and route validation. Items are addressed by their integer item id; add
// endpoints take a 1-based order and mint the id.
export default class surveyItemApi {
  static async getItemsBySurveyId(surveyId) {
    return request({url: surveyItem.getItemsBySurveyId(surveyId), method: 'GET'})
  }

  static async addContentScreen({surveyId, order, content}) {
    return request({
      url: surveyItem.addContentScreen(),
      method: 'POST',
      data: {surveyId, order, content},
    })
  }

  static async updateContentScreen({surveyId, itemId, content}) {
    return request({
      url: surveyItem.updateContentScreen(),
      method: 'PUT',
      data: {surveyId, itemId, content},
    })
  }

  static async deleteContentScreen(surveyId, itemId) {
    return request({
      url: surveyItem.deleteContentScreen(surveyId, itemId),
      method: 'DELETE',
    })
  }

  static async addSkipLogicSection({surveyId, order, rules}) {
    return request({
      url: surveyItem.addSkipLogicSection(),
      method: 'POST',
      data: {surveyId, order, rules},
    })
  }

  static async updateSkipLogicSection({surveyId, itemId, rules}) {
    return request({
      url: surveyItem.updateSkipLogicSection(),
      method: 'PUT',
      data: {surveyId, itemId, rules},
    })
  }

  static async deleteSkipLogicSection(surveyId, itemId) {
    return request({
      url: surveyItem.deleteSkipLogicSection(surveyId, itemId),
      method: 'DELETE',
    })
  }

  static async reorder(surveyId, fromItemId, toIndex) {
    return request({
      url: surveyItem.reorder(surveyId, fromItemId, toIndex),
      method: 'GET',
    })
  }

  static async validateRoutes(surveyId) {
    return request({url: surveyItem.validateRoutes(surveyId), method: 'GET'})
  }
}
